// Components
import dayjs from "dayjs"
import "dayjs/locale/de"
import "dayjs/locale/en-gb"
import "dayjs/locale/es"
import "dayjs/locale/fr"
import "dayjs/locale/it"
import "dayjs/locale/nl"
import "dayjs/locale/pt"
import "dayjs/locale/ru"
import "dayjs/locale/zh-cn"
import localeData from "dayjs/plugin/localeData"
import updateLocale from "dayjs/plugin/updateLocale"
import { Provider } from "react-redux"
import { RouterProvider } from "react-router-dom"
// import { HistoryRouter as Router } from "redux-first-history/rr6"
import { PersistGate } from "redux-persist/integration/react"

// Styles
import "./components/Forms/Form.less"
import { NewVersionBanner } from "./components/NewVersionBanner/NewVersionBanner.tsx"
import { router } from "./containers/InitComponent/router/router.tsx"
import "./containers/LoginPage/styles/styles.less"
import DayjsProvider from "./providers/DayjsProvider"
import { type StoreConfig } from "./store"
import "./styles/app.less"
import "./styles/index.less"
import "./styles/tailwind.css"
import "./styles/video.less"
import { isChunkLoadError } from "./utils/handlers/is-chunk-load-error.ts"
import {
  reloadForChunkError,
  scheduleChunkReloadReset
} from "./utils/handlers/reload-for-chunk-error.ts"

// Extend dayjs with plugins
dayjs.extend(localeData)
dayjs.extend(updateLocale)

// Configure dayjs locale
dayjs.updateLocale("en-gb", {
  weekdaysMin: ["S", "M", "T", "W", "T", "F", "S"],
  monthsShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
})

// Extended Document interface for visibility API
interface DocumentWithVisibility extends Document {
  visible?: boolean
}

// Handle visibility change
document.addEventListener("visibilitychange", (): void => {
  const doc = document as DocumentWithVisibility
  if (!doc.visible) {
    const activeElement = document.activeElement as HTMLElement
    activeElement?.blur()
  }
})

// Обробка помилки застарілих chunks після деплою
window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault()
  reloadForChunkError()
})

// Додатково для dynamic import помилок
window.addEventListener("error", (event) => {
  if (isChunkLoadError(event)) {
    event.preventDefault()
    reloadForChunkError()
  }
})

// Для unhandled promise rejections (dynamic imports)
window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault()
    reloadForChunkError()
  }
})

scheduleChunkReloadReset()

// Handle scroll events
const handleScroll = (): void => {
  const globalWrap = document.getElementById(
    "global-wrap"
  ) as HTMLElement | null

  if (globalWrap?.style.overflow === "hidden") {
    document.body.style.overflow = "hidden"
  } else {
    document.body.style.overflow = "unset"
  }
}

document.addEventListener("scroll", handleScroll, false)
document.addEventListener("wheel", handleScroll, { passive: false })

interface AppProps {
  store: StoreConfig
}

const App = ({ store }: AppProps) => {
  return (
    <Provider store={store.store}>
      <PersistGate loading={null} persistor={store.persistor}>
        {/*<Router history={store.history}>*/}
        <DayjsProvider>
          <RouterProvider router={router} />
          <NewVersionBanner />
        </DayjsProvider>
        {/*</Router>*/}
      </PersistGate>
    </Provider>
  )
}

export default App
